module.exports = __webpack_public_path__ + "img/1f9c9.cd2adb7.svg";